export const environment = {
  apiUrl: 'https://erne.cloud.triarc-labs.com',
  auth: {
    clientId: 'ea9ace0c-041f-4a0f-910a-705b2fc8d863',
    authority: 'https://login.microsoftonline.com/b4ae1b37-83f5-4544-b134-9bbbdd664ec5',
    mode: 'keycloak',
    keycloak: {
      url: 'https://auth.cloud.triarc-labs.com/auth',
      realm: 'erne',
      clientId: 'erne-time',
    },
  },
};
